import { ReferralMetaType } from '@/modules/referral/constants/ReferralMetaType';
import { Referral } from '@/modules/referral/models/Referral';
import { ReferralVaultMeta } from '@/modules/referral/models/meta/ReferralVaultMeta';
import { ReferralSettlementMeta } from '@/modules/referral/models/meta/ReferralSettlementMeta';

export class ReferralMetaFactory {
  static build(model: Partial<Referral>): ReferralVaultMeta | ReferralSettlementMeta | null {
    switch (model.metaType) {
      case ReferralMetaType.REFERRAL_VAULT_META:
        return ReferralVaultMeta.mapModel(model.meta);
      case ReferralMetaType.REFERRAL_SETTLEMENT_META:
        return ReferralSettlementMeta.mapModel(model.meta);
      default:
        return null;
    }
  }
}
